import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { msalConfig } from './authConfig';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { PopupProvider } from './context/PopupContext';
import NotificationProvider from './context/NotificationContext';
import { ButtonDisableProvider } from "./context/ButtonDisableProvider";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <MsalProvider instance={msalInstance}>
    <React.StrictMode>
      <NotificationProvider>
      <ButtonDisableProvider>
        <BrowserRouter>
          <Provider store={store}>
            <PopupProvider>
              <App />
            </PopupProvider>
          </Provider>
        </BrowserRouter>
      </ButtonDisableProvider>
      </NotificationProvider>
    </React.StrictMode>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
